import { Step, StepButton, Stepper, Typography, Box } from "@mui/material";
import StepIconCustom from "../StepIconCustom";
import CheckIcon from "@mui/icons-material/Check";
import { useState, useMemo, memo } from "react";

const StepContent = memo(({ component: Component, active, ...props }) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflow: "auto",
        display: active ? "block" : "none",
      }}
    >
      <Component {...props} />
    </Box>
  );
});

const StepsGeneric = memo(
  ({
    steps = [],
    stepsComponents = [],
    activeStep,
    setActiveStep,
    complementaryHeader,
    ...componentsProps
  }) => {
    const [hasReachedLastStep, setHasReachedLastStep] = useState(false);

    const stepComponents = useMemo(
      () =>
        stepsComponents.map((Component, index) => (
          <StepContent
            key={`step-${index}`}
            component={Component}
            active={activeStep === index}
            lastStep={setHasReachedLastStep}
            handleStep={setActiveStep}
            {...componentsProps}
          />
        )),
      [stepsComponents, activeStep, componentsProps]
    );

    const handleStep = (step) => {
      setActiveStep(step);
    };

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
        }}
      >
        <Box>
          <Stepper
            nonLinear={hasReachedLastStep}
            activeStep={activeStep}
            alternativeLabel
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepButton
                  icon={
                    !hasReachedLastStep ? (
                      activeStep >= index ? (
                        <StepIconCustom color={"#0f2047"}>
                          {index + 1}
                        </StepIconCustom>
                      ) : (
                        <StepIconCustom color={"lightgray"}>
                          {index + 1}
                        </StepIconCustom>
                      )
                    ) : activeStep === index ? (
                      <StepIconCustom color={"#4b6fc0"}>
                        <CheckIcon sx={{ fontSize: "1rem" }} />
                      </StepIconCustom>
                    ) : (
                      <StepIconCustom color={"#0f2047"}>
                        <CheckIcon sx={{ fontSize: "1rem" }} />
                      </StepIconCustom>
                    )
                  }
                  onClick={() => handleStep(index)}
                >
                  <Typography variant="body1" sx={{ display: "block" }}>
                    {label}
                  </Typography>
                </StepButton>
              </Step>
            ))}
          </Stepper>
          {complementaryHeader && <div>{complementaryHeader}</div>}
        </Box>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {stepComponents}
        </Box>
      </Box>
    );
  }
);

StepsGeneric.displayName = "StepsGeneric";
export default StepsGeneric;
